import { Button } from "react-aria-components";
import { Intent, IRecallItem } from "./recallData"
import { ResultType } from "../../../enums/ResultTypes";

interface Step2ListButton {
    inventoryItem: any,
    currentInventory: IRecallItem[]
    handleAddToRecallButton: Function
    handleSelectInventoryButton: Function
}
export default function Step2ListButton({ inventoryItem, currentInventory, handleAddToRecallButton, handleSelectInventoryButton }: Step2ListButton) {

    const GetText = (inventoryItem: any) => {
        let text: string | undefined = undefined
        const wholeBoxIds = currentInventory?.filter(x => x.intent === Intent.WholeBox).map(x => x.packingBoxId) ?? [];

        if (inventoryItem.resultType == ResultType.PartCase) {
            currentInventory?.forEach((x) => {
                if (wholeBoxIds.length > 0 && inventoryItem.packingBoxId === x.packingBoxId && wholeBoxIds.includes(x.packingBoxId)) {
                    text = GetInventoryItemText(x, text);
                } else {
                    if (x.caseId == inventoryItem.caseId) {
                        if (x.intent === Intent.PartCase && x.partCases.flat().findIndex(y => y.specimenId === inventoryItem.specimenId) > -1) {
                            text = "Added"
                        }
                        else if (x.intent !== Intent.PartCase) {
                            text = "Added"
                        }
                    }
                }
            });
            return <div className="display--flex justifyContent--flex-end alignItems--center gap--xxs">
                {text && inventoryItem.canBeRecalled && <p>{text}</p>}
                <Button isDisabled={!inventoryItem.canBeRecalled || text} className="button button--small button--primary" onPress={() => { handleAddToRecallButton(inventoryItem) }}>
                    Add to recall
                </Button>
            </div>
        }

        if (inventoryItem.resultType == ResultType.WholeCase) {
            currentInventory?.forEach((x) => {
                if (wholeBoxIds.length > 0 && inventoryItem.packingBoxId === x.packingBoxId && wholeBoxIds.includes(x.packingBoxId)) {
                    text = GetInventoryItemText(x, text);
                } else {
                    if (x.caseId == inventoryItem.caseId) {
                        text = GetInventoryItemText(x, text);
                    }
                }
            });
            return <div className="display--flex justifyContent--flex-end alignItems--center gap--xxs">
                {text && inventoryItem.canBeRecalled && <p>{text}</p>}
                <Button isDisabled={!inventoryItem.canBeRecalled || text} className="button button--small button--primary" onPress={() => { handleSelectInventoryButton(inventoryItem) }}>
                    Select inventory
                </Button>
            </div>
        }

        if (inventoryItem.resultType === ResultType.Range) {
            currentInventory?.forEach((x) => {
                if (wholeBoxIds.length > 0 && inventoryItem.packingBoxId === x.packingBoxId && wholeBoxIds.includes(x.packingBoxId)) {
                    text = GetInventoryItemText(x, text);
                } else {
                    if (x.reference == inventoryItem.reference && x.rangeId == inventoryItem.rangeId) {
                        text = GetInventoryItemText(x, text);
                    }
                }
            })

            return <div className="display--flex justifyContent--flex-end alignItems--center gap--xxs">
                {text && inventoryItem.canBeRecalled && <p>{text}</p>}
                <Button isDisabled={!inventoryItem.canBeRecalled || text} className="button button--small button--primary" onPress={() => { handleSelectInventoryButton(inventoryItem) }}>
                    Select inventory
                </Button>
            </div>
        }
    }


    return <>{GetText(inventoryItem)}</>
}

function GetInventoryItemText(x: IRecallItem, text: string | undefined) {
    if (x.intent === Intent.PartCase) {
        text = "Parts Added";
    }
    else {
        text = "Added";
    }
    return text;
}
